import * as React from "react";
const SvgDashboard20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "black",
        viewBox: "0 0 16 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v7h7V0H1Zm1 5V2h3v3H2ZM1 9H0v7h7V9H1Zm1 5v-3h3v3H2ZM9 0h7v7H9V0Zm2 2v3h3V2h-3Zm-1 7H9v7h7V9h-6Zm1 5v-3h3v3h-3Z",
      clipRule: "evenodd"
    })
  );
export default SvgDashboard20Px;
